import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Search, Menu, X } from "lucide-react";

export const Navbar = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");

  const cats = [
    { name: "Toys", slug: "toys" },
    { name: "Gadgets", slug: "gadgets" },
    { name: "Beauty", slug: "beauty" },
    { name: "Pets", slug: "pets" },
    { name: "Fitness", slug: "fitness" },
    { name: "Garden", slug: "garden" },
  ];

  const submitSearch = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/search?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-zinc-200">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-testid="logo-link" className="font-display font-black text-xl tracking-tighter uppercase">
            Curated<span className="text-[#FF2A00]">.</span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {cats.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                data-testid={`nav-cat-${c.slug}`}
                className="text-sm font-medium text-zinc-700 hover:text-[#FF2A00] transition-colors duration-300"
              >
                {c.name}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <form onSubmit={submitSearch} className="hidden md:flex items-center border border-zinc-300 focus-within:border-black transition-colors duration-300">
              <input
                data-testid="search-input"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Search products"
                className="px-3 py-1.5 text-sm outline-none w-40 bg-transparent"
              />
              <button type="submit" data-testid="search-submit" className="px-3 py-1.5 text-zinc-600 hover:text-black">
                <Search size={16} />
              </button>
            </form>
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen(!open)}
              className="lg:hidden p-2"
            >
              {open ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-zinc-200 bg-white px-6 py-4 space-y-3">
          <form onSubmit={submitSearch} className="flex items-center border border-zinc-300 mb-3">
            <input
              data-testid="search-input-mobile"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search products"
              className="px-3 py-2 text-sm outline-none flex-1 bg-transparent"
            />
            <button type="submit" className="px-3 text-zinc-600"><Search size={16} /></button>
          </form>
          {cats.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              onClick={() => setOpen(false)}
              className="block text-sm font-medium text-zinc-700 hover:text-[#FF2A00]"
            >
              {c.name}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
